
import { TranslationsByLanguage, PluralTranslation } from './types';

export type ClipsTranslationKey =
  | 'clip.license'
  | 'clip.download'
  | 'clip.views'
  | 'clip.downloads'
  | 'clip.relatedClips'
  | 'clip.derivativeWorks'
  | 'clip.createDerivative'
  | 'clip.description'
  | 'clip.view'
  | 'clip.share'
  | 'clip.save'
  | 'clip.noDerivatives'
  | 'clip.licenseTerms'
  | 'clip.licenseDescription'
  | 'clip.requiredMentions'
  | 'clip.requiredHashtags'
  | 'clip.shareVia'
  | 'clips.allClips'
  | 'clips.searchPlaceholder'
  | 'clips.view'
  | 'clip.downloadStarted'
  | 'clip.downloadSuccess'
  | 'clip.downloadFailed'
  | 'clip.downloadError'
  | 'clip.notFound'
  | 'clip.notFoundDescription'
  | 'clip.tags'
  | 'clip.derivatives'
  | 'clip.noLicenseInfo'
  | 'explore.clips.title'
  | 'explore.clips.description'
  | 'clips.description';

export const clipsTranslations: TranslationsByLanguage = {
  en: {
    'clip.license': 'License',
    'clip.download': 'Download',
    'clip.views': 'Views',
    'clip.downloads': 'Downloads',
    'clip.relatedClips': 'Related Clips',
    'clip.derivativeWorks': 'Derivative Works',
    'clip.createDerivative': 'Create Derivative Work',
    'clip.description': 'Description',
    'clip.view': 'View',
    'clip.share': 'Share',
    'clip.save': 'Save',
    'clip.noDerivatives': 'No derivative works have been created from this clip yet.',
    'clip.licenseTerms': 'License Terms',
    'clip.licenseDescription': 'Required attribution for using this content',
    'clip.requiredMentions': 'Required Mentions',
    'clip.requiredHashtags': 'Required Hashtags',
    'clip.shareVia': 'Share via',
    'clips.allClips': 'All Clips',
    'clips.searchPlaceholder': 'Search clips...',
    'clips.view': 'View',
    'clip.downloadStarted': 'Download Started',
    'clip.downloadSuccess': 'Your download will begin shortly',
    'clip.downloadFailed': 'Download Failed',
    'clip.downloadError': 'There was an error downloading this clip',
    'clip.notFound': 'Clip Not Found',
    'clip.notFoundDescription': 'The clip you are looking for does not exist or has been removed',
    'clip.tags': 'Tags',
    'clip.derivatives': 'Derivatives',
    'clip.noLicenseInfo': 'No license information available for this clip',
    'explore.clips.title': 'Premium Video Clips',
    'explore.clips.description': 'Browse our collection of high-quality video clips for your creative projects',
    'clips.description': 'Discover individual video clips available for licensing and creative use'
  },
  fr: {
    'clip.license': 'Licence',
    'clip.download': 'Télécharger',
    'clip.views': 'Vues',
    'clip.downloads': 'Téléchargements',
    'clip.relatedClips': 'Clips Similaires',
    'clip.derivativeWorks': 'Oeuvres Dérivées',
    'clip.createDerivative': 'Créer une Oeuvre Dérivée',
    'clip.description': 'Description',
    'clip.view': 'Voir',
    'clip.share': 'Partager',
    'clip.save': 'Sauvegarder',
    'clip.noDerivatives': 'Aucune œuvre dérivée n\'a encore été créée à partir de ce clip.',
    'clip.licenseTerms': 'Conditions de Licence',
    'clip.licenseDescription': 'Attribution requise pour l\'utilisation de ce contenu',
    'clip.requiredMentions': 'Mentions Requises',
    'clip.requiredHashtags': 'Hashtags Requis',
    'clip.shareVia': 'Partager via',
    'clips.allClips': 'Tous les Clips',
    'clips.searchPlaceholder': 'Rechercher des clips...',
    'clips.view': 'Voir',
    'clip.downloadStarted': 'Téléchargement Commencé',
    'clip.downloadSuccess': 'Votre téléchargement va commencer dans un instant',
    'clip.downloadFailed': 'Échec du Téléchargement',
    'clip.downloadError': 'Une erreur s\'est produite lors du téléchargement de ce clip',
    'clip.notFound': 'Clip Non Trouvé',
    'clip.notFoundDescription': 'Le clip que vous recherchez n\'existe pas ou a été supprimé',
    'clip.tags': 'Tags',
    'clip.derivatives': 'Œuvres Dérivées',
    'clip.noLicenseInfo': 'Aucune information de licence disponible pour ce clip',
    'explore.clips.title': 'Clips Vidéo Premium',
    'explore.clips.description': 'Parcourez notre collection de clips vidéo de haute qualité pour vos projets créatifs',
    'clips.description': 'Découvrez des clips vidéo individuels disponibles pour la licence et l\'utilisation créative'
  }
};
